import { defineMessages } from 'react-intl';

export default defineMessages({
    account: {
        id: 'header.links.Account',
        defaultMessage: 'Account'
    },
    faq: {
        id: 'header.links.FAQ',
        defaultMessage: 'FAQ'
    },
    logout: {
        id: 'header.links.Logout',
        defaultMessage: 'Logout'
    },
    authorizedUser: {
        id: 'tdic.header.links.Authorized User',
        defaultMessage: 'Authorized User'
    },
    payMyBill: {
        id: 'tdic.header.links.Pay My Bill',
        defaultMessage: 'Pay My Bill'
    },
    makePayment: {
        id: 'tdic.header.links.Make Payment',
        defaultMessage: 'Make Payment'
    },
    managePaymentPlan: {
        id: 'tdic.header.links.Manage Payment Plan',
        defaultMessage: 'Manage Payment Plan'
    },
    requestQuote: {
        id: 'tdic.header.links.Request a Quote',
        defaultMessage: 'Request a Quote'
    },
    myAccountDetails: {
        id: 'tdic.header.links.My Account Details',
        defaultMessage: 'My Account Details'
    },
    noNewNotification: {
        id: 'tdic.header.links.No new notification',
        defaultMessage: 'There are no notifications.'
    },
    renewalSurveyNotify: {
        id: 'tdic.header.links.Policy Update needed. Details are needed to update your policy.',
        defaultMessage: 'Details are needed to update your policy. Complete the {policyQuestionnaireLink} by {date}.'
    },
    policyQuestionnaire: {
        id: 'tdic.header.links.Policy Questionnaire',
        defaultMessage: 'Policy Questionnaire'
    },
});
